module.exports = __webpack_public_path__ + "static/img/hud_main_circle.5a18fb02.png";